import { Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { Else, If, Then } from "react-if";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";

import { Steps, Switch, Tooltip } from "antd";
import NoInternetAction from "../../../../actions/noInternetAction";
import { setPopup } from "../../../../actions/popupAction";
import { ErrorYellowIcon, MultiLanguageInfoIcon } from "../../../../assets/svg";
import BottomBar from "../../../../components/bottomBar";
import CommonFields from "../../../../components/commonFields";
import ConfirmPopup from "../../../../components/confirmPopup";
import useWindowDimensions from "../../../../components/custom-hooks/useWindowDimensions";
import CustomButton from "../../../../components/customButton";
import CustomLabel from "../../../../components/customLabel";
import LoadingSpinner from "../../../../components/loadingSpinner";
import CustomNotification from "../../../../components/notification";
import UploadFile from "../../../../components/uploadFile";
import {
  CONVO_TYPE,
  MOBILE_WIDTH,
  PRACTICE_EDITION_WHITELABEL,
  newLineRegex,
} from "../../../../constants/constants";
import { getFormData } from "../../../../helper/helpers";
import {
  broadCastMessageAction,
  broadCastMessageReviewAction,
  broadCastPatientListAction,
  removeBroadCastPatientAction,
  uploadBroadCastCommaSeparatedValuesAction,
  uploadBroadCastFileNewAction,
} from "../../../../sagas/saga-broadcast";
import BroadcastService from "../../../../service/BroadcastUserService";
import loginService from "../../../../service/login";
import { directTextInputValidation, fileUploadOptions } from "../../constants";
import { DebouncedDirectTextInput } from "../deboundedDirectTextInput/debouncedDirectTextInput";
import BroadcastMessage from "../BroadcastMessage/BroadcastMessage";
import InitiateBroadcast from "../InitiateBroadcast/initiateBroadcast";
import SaveFile from "../saveFile/index";
import SelectFile from "../selectFile/index";
import MobileHeader from "../../../../components/header/mobileHeader";
import "./styles.scss";

const { Step } = Steps;
const PATIENT_MULTI_LANG_STORAGE_KEY = "broadcast_patient_is_multi_lang";
const IS_NON_PROD = !process.env.REACT_APP_ENV?.endsWith("prod"); 
const getPersistedMultiLangValue = () => {
  try {
    const value = localStorage.getItem(PATIENT_MULTI_LANG_STORAGE_KEY);
    return value === null ? false : value === "true";
  } catch (e) {
    return false;
  }
};

const PatientBroadcast = (props) => {
  const steps = [
    {
      title: "First",
      content: "",
    },
    {
      title: "Second",
      content: "",
    },
    {
      title: "Last",
      content: "Last-content",
    },
  ];
  const [current, setCurrent] = useState(0);
  const { width } = useWindowDimensions();
  const next = () => {
    setCurrent(current + 1);
  };
  const prev = () => {
    setCurrent(current - 1);
  };
  const broadcastService = new BroadcastService();

  const [state, setState] = useState({
    convoType: "",
    data: [],
    isReset: false,
    errorMessage: null,
    file: undefined,
    fileUploaded: false,
    filterText: "",
    filterData: [],
    headers: [],
    confirmPopup: false,
    reviewMsg: "",
    showtable: false,
    loading: true,
    filename: "",
    customFileId: "",
    fileId: "",
    broadcastInitiated: false,
    delimiter: "pipe",
    saveFileLayout: false,
    customFileName: "",
    saveFile: false,
    fileNameError: "",
    selectFile: PRACTICE_EDITION_WHITELABEL,
    useCustomFile: "",
    preview: false,
    isDirectTextInput: false,
    isMultiLang: false,
    isTwilioDisabled: localStorage.getItem("isTwilioDisabled") === "true",
    allowDuplicate: localStorage.getItem("allowDuplicate_patient") === "true",
  });

  const { isDirectTextInput } = state;
  const { customPopupMessage, messageType, message } = props.popupReducer;

  const { editDeleteAccess, handleEmailTemplateData } = props;

  const selectFileRef = useRef();

  const isTranslationEnable =
    typeof loginService.getEnableTranslation === "function"
      ? loginService.getEnableTranslation()
      : false;

  const fetchBroadcastPatientList = () => {
    try {
      props.broadCastPatientList({}, (status, response) => {
        const { data, count } = response || {};

        if (status && data && data.length) {
          const headers = JSON.parse(data[0].headers);

          const fields = data.map((item) => ({
            id: item.id,
            ...JSON.parse(item.fields),
          }));

          setState((st) => ({
            ...st,
            fileUploaded: true,
            data: fields,
            filename: data[0] ? data[0].fileName : "",
            fileId: data[0] ? data[0].fileId : "",
            customFileId: data?.[0]?.customFileId || "",
            showtable: true,
            headers,
            loading: false,
            count,
            errorMessage: null,
            selectFile: false,
            isDirectTextInput: data[0]?.fileName?.length ? false : true,
            isMultiLang: getPersistedMultiLangValue(),
          }));
          setCurrent(1);
        } else {
          setState((st) => ({
            ...st,
            fileUploaded: false,
            loading: false,
            saveFile: false,
            customFileName: "",
            isMultiLang: false,
          }));
          setCurrent(0);
        }
      });
    } catch (e) {
      setState((st) => ({
        ...st,
        loading: false,
      }));
    }
  };

  const upload = () => {
    const checkConnection = window.navigator.onLine ? "on" : "off";

    if (checkConnection === "off") {
      setState((st) => ({
        ...st,

        fileUploaded: false,
        loading: false,
        confirmPopup: false,
      }));
      setCurrent(0);
      props.setPopup({
        customPopupMessage: true,
        message: "You are offline, Please check your internet connection",
        messageType: "error",
      });
    } else {
      setState((st) => ({
        ...st,
        loading: true,
        confirmPopup: false,
      }));
      const { delimiter, saveFile, file, customFileName, isMultiLang } = state;
      const isMultiLangEnabledForCurrentMode =
        delimiter !== "commaSeparatedValues" && isMultiLang;
      const formData = new FormData();
      formData.append("userType", "patient");
      formData.append("delimiter", delimiter);
      formData.append("saveFile", saveFile);
      formData.append("fileNickName", customFileName);
      formData.append("file", file);
      formData.append("isMultiLang", isMultiLangEnabledForCurrentMode);
      formData.append("allowDuplicate", state.allowDuplicate);
      props.uploadBroadCastFile(formData, (status, data) => {
        if (status) {
          setState((st) => ({
            ...st,
            loading: true,
            fileUploaded: true,
            errorMessage: null,
          }));
          setCurrent(1);
          fetchBroadcastPatientList();
        } else {
          if (!state.saveFile) {
            props.setPopup({
              customPopupMessage: true,
              message: data,
              messageType: "error",
            });

            setState((st) => ({
              ...st,
              errorMessage: "No patient record found or file limit exceeds",
              loading: false,
            }));
          } else {
            setState((st) => ({
              ...st,
              fileNameError: data,
              loading: false,
            }));
          }
        }
      });
    }
  };
  const handleTwilioDisabledToggle = (checked) => {
  try {
    localStorage.setItem("isTwilioDisabled", String(checked));
  } catch (e) {
    console.log(e);
  }
  setState((st) => ({ ...st, isTwilioDisabled: checked }));
};
const handleAllowDuplicateToggle = (checked) => {
  try {
    localStorage.setItem("allowDuplicate_patient", String(checked));
  } catch (e) {
    console.log(e);
  }
  setState((st) => ({ ...st, allowDuplicate: checked }));
};

  const broadcastMessage = async (message) => {
    if (!props.noInternet.noInternetMessage) {
      setState((st) => ({
        ...st,
        loading: true,
      }));
      const practiceId = loginService.getPracticeId();
      const isMultiLangEnabledForCurrentMode =
        state.delimiter !== "commaSeparatedValues" && state.isMultiLang;

      const broadcastObj = {
        practiceId,
        filename: state.filename,
        customFileId: state.customFileId,
        isMultiLang: isMultiLangEnabledForCurrentMode,
        translationObject: message.translationObject || {},
        message: message || message?.rcsMessage,
        fileId: state.fileId,
        userType: "patient",
        allowDuplicate: state.allowDuplicate,
        convoType: message.convoType,
        selectAll: true,
        selectedCount: state.count,
        emailSubject: message.emailSubject,
        emailColumn: message.emailColumn,
        emailTemplateId: message.emailTemplateId,
        ivrMessage: message.ivrMessage,
        ivrTemplate: message.ivrTemplate,
        useSmsForIVR: message.useSmsForIVR,
        optOutMessage: message.optOutMessage,
        optOutTemplate: message.optOutTemplate,
        enableOptOut: message.enableOptOut,
        responseTemplate: message.responseTemplate,
        responseMessage: message.responseMessage,
        subtype:
          message.convoType === "ivr" && message.subtype ? "audio" : "text",
        // only for non prod environment
        isTwilioDisabled: IS_NON_PROD 
        ? state.isTwilioDisabled  
        : localStorage.getItem("isTwilioDisabled") === "true",
        countryCodeForRcs: localStorage.getItem("countryCodeForRcs") || "",
      };
      const payloadData = {
        body: JSON.stringify(broadcastObj),
        audio: message.audio,
      };
      const formData = getFormData(payloadData);

      props.broadCastMessage(formData, (status, msg) => {
        props.setPopup({
          customPopupMessage: true,
          message: "Broadcast has been queued please check report for status",
          messageType: "success",
        });

        if (status) {
          props.setPopup({
            customPopupMessage: true,
            message: "Message broadcast successfully",
            messageType: "success",
          });
          localStorage.setItem(PATIENT_MULTI_LANG_STORAGE_KEY, "false");

          setState((st) => ({
            ...st,
            loading: false,
            errorMessage: null,
            broadcastInitiated: true,
          }));
        } else {
          setState((st) => ({
            ...st,
            loading: false,
            isMultiLang: false,
          }));

          props.setPopup({
            customPopupMessage: true,
            message: msg,
            messageType: "error",
          });
        }
      });
    } else {
      props.setPopup({
        customPopupMessage: true,
        message: props.noInternet.noInternetMessage,
        messageType: "error",
      });
    }
  };

  const cancel = () => {
    try {
      localStorage.setItem(PATIENT_MULTI_LANG_STORAGE_KEY, "false");
    } catch (e) {
      console.log(e);
    }

    setState((st) => ({
      ...st,
      loading: true,
    }));

    try {
      props.removeBroadCastPatient({ fileId: state.fileId }, (status) => {
        if (status) {
          setState((st) => ({
            ...st,
            file: undefined,
            fileUploaded: false,
            filterText: "",
            filterKey: "",
            filterData: [],
            showtable: false,
            data: [],
            loading: false,
            delimiter: "pipe",
            saveFile: false,
            saveFileLayout: false,
            customFileName: "",
            selectFile: false,
            useCustomFile: "",
            isMultiLang: false,
          }));
          setCurrent(0);
        }
      });
    } catch (err) {
      setState((st) => ({
        ...st,
        loading: false,
      }));
    }
  };

  const handleResend = () => {
    setState((st) => ({
      ...st,
      broadcastInitiated: false,
      loading: true,
      file: undefined,
      showtable: false,
      saveFile: false,
      selectFile: false,
      saveFileLayout: false,
      customFileName: "",
    }));
    if (width < MOBILE_WIDTH) {
      props.handleBackButton();
    } else {
      fetchBroadcastPatientList();
    }
  };

  const handleResetFileData = () => {
    setState((st) => ({
      ...st,
      file: [],
      isReset: true,
      errorMessage: "",
      saveFileLayout: false,
    }));
  };

  const setFile = (value, error, sizeErr, saveFileLayout) => {
    setState((st) => ({
      ...st,
      file: value[0] && value[0].originFileObj,
      errorMessage: sizeErr,
      saveFileLayout: saveFileLayout,
    }));
  };

  const hideInitiateBroadcast = () => {
    setState((st) => ({
      ...st,
      broadcastInitiated: false,
    }));
  };

  const fetchTableData = (filters) => {
    return new Promise((resolve, reject) => {
      const { order: sortBy, search, ...others } = filters;
      const filter = search ? encodeURIComponent(JSON.stringify(search)) : "";
      props.broadCastPatientList(
        { ...others, filter, sortBy },
        (status, response) => {
          const { data, count } = response || {};
          if (status && data && data.length) {
            const fields = data.map((item) => ({
              id: item.id,
              ...JSON.parse(item.fields),
            }));
            setState((st) => ({
              ...st,
              isDirectTextInput: data[0]?.fileName?.length ? false : true,
            }));
            resolve({ rows: fields, count });
          }
          resolve({ rows: [], count: 0 });
        },
      );
    });
  };

  const getSuggestions = async (column, value) => {
    const data = await broadcastService.getSuggestionsPatient(column, value);
    return data || [];
  };

  const getScheduledMsgData = (message) => {
    const isMultiLangEnabledForCurrentMode =
      state.delimiter !== "commaSeparatedValues" && state.isMultiLang;
    let data = {
      filename: state.filename,
      customFileId: state.customFileId,
      isMultiLang: isMultiLangEnabledForCurrentMode,
      message: message,
      fileId: state.fileId,
      userType: "patient",
      convoType: message.convoType,
      selectAll: true,
      selectedCount: state.count,
    };
    return data;
  };

  const getSavedFileContent = async () => {
    setState((st) => ({ ...st, loading: true }));
    try {
      const { useCustomFile } = state;
      const isMultiLangEnabledForCurrentMode =
        state.delimiter !== "commaSeparatedValues" && state.isMultiLang;
      const content = await broadcastService.getSavedFileContent(
        useCustomFile,
        "patient",
        isMultiLangEnabledForCurrentMode,
      );

      const { data, count } = content || {};

      if (data && data.length) {
        const headers = JSON.parse(data[0].headers);

        const fields = data.map((item) => ({
          id: item.id,
          ...JSON.parse(item.fields),
        }));

        setState((st) => ({
          ...st,
          fileUploaded: true,
          data: fields,
          filename: data[0] ? data[0].fileName : "",
          fileId: data[0] ? data[0].fileId : "",
          customFileId: data?.[0]?.customFileId || "",
          showtable: true,
          headers,
          loading: false,
          count,
          errorMessage: null,
          useCustomFile: "",
        }));
      }
    } catch (err) {
      setState((st) => ({ ...st, loading: false }));
    }
  };
  const showBroadcastResend = () => {
    setState((st) => ({
      ...st,
      broadcastInitiated: true,
      loading: false,
    }));
  };

  const handleParentLoading = (loading = true) => {
    setState((st) => ({
      ...st,
      loading,
    }));
  };

  const showConfirmPopup = () => {
    setState((st) => ({
      ...st,
      confirmPopup: true,
    }));
  };

  const getCustomeFileName = (val) => {
    setState((st) => ({
      ...st,
      customFileName: val,
      saveFile: true,
      fileNameError: "",
    }));
    showConfirmPopup();
  };

  const resetFileNameErr = () => {
    setState((st) => ({
      ...st,
      fileNameError: "",
    }));
  };

  const hideConfirmPopup = () => {
    setState((st) => ({
      ...st,
      confirmPopup: false,
      saveFile: false,
      customFileName: "",
    }));
  };

  const handleTypeChange = (e) => {
    setState((st) => {
      return {
        ...st,
        delimiter: e.target.value,
      };
    });
    handleBack();
  };

  const handleBack = () => {
    setState((st) => ({
      ...st,
      file: undefined,
      saveFileLayout: false,
      isReset: true,
      saveFile: false,
      customFileName: "",
      fileNameError: "",
      selectFile: false,
      sMultiLang: false,
    }));
  };

  const handleRecentUploads = () => {
    setState((st) => ({
      ...st,
      selectFile: true,
    }));
  };

  const handleUseCustomFile = (file) => {
    setState((st) => ({
      ...st,
      useCustomFile: file.fileNickName,
    }));
  };

  const handleLoading = (flg) => {
    setState((st) => ({
      ...st,
      loading: flg,
    }));
  };

  const backButtonClicked = () => {
    switch (current) {
      case 0:
        props.handleBackButton();
        return;
      case 1:
        cancel();
        return;
      case 2:
        if (!state.broadcastInitiated) {
          prev();
        } else {
          props.handleBackButton();
        }
        return;
      case 3:
        prev();
        return;
      default:
        return;
    }
  };

  const handlePreview = (preview) => {
    setState((st) => ({
      ...st,
      preview,
    }));
  };

  const handleMultiLanguageToggle = (checked) => {
    try {
      localStorage.setItem(PATIENT_MULTI_LANG_STORAGE_KEY, String(checked));
    } catch (e) {
      console.log(e);
    }

    setState((st) => ({
      ...st,
      isMultiLang: checked,
    }));
  };

  const handleMobFileSelect = (file) => {
    setState((st) => ({
      ...st,
      file,
    }));
  };
  const handleCommaSeparatedValuesUpload = (values) => {
    setState((st) => ({ ...st, loading: true, confirmPopup: false }));

    const updatedValues = values.commaSeparatedText?.replace(newLineRegex, "");
    const isMultiLangEnabledForCurrentMode =
      state.delimiter !== "commaSeparatedValues" && state.isMultiLang;

    const payload = {
      userType: "patient",
      values: updatedValues,
      isMultiLang: isMultiLangEnabledForCurrentMode,
      allowDuplicate: state.allowDuplicate,
    };
    props.uploadBroadCastCommaSeparatedValues(payload, (status, data) => {
      if (status) {
        setState((st) => ({
          ...st,
          loading: true,
          fileUploaded: true,
          isDirectTextInput: true,
          headers: data.headers,
          errorMessage: null,
        }));
        setCurrent(1);
        fetchBroadcastPatientList();
      } else {
        if (!state.saveFile) {
          setCurrent(0);
          props.setPopup({
            customPopupMessage: true,
            message: data,
            messageType: "error",
          });

          setState((st) => ({
            ...st,
            errorMessage: "Unable to add values through direct input.",
            loading: false,
          }));
        } else {
          setState((st) => ({ ...st, fileNameError: data, loading: false }));
        }
      }
    });
  };
  const handleNextButton = (values) => {
    if (current === 0 && isCommaSeparatedValues) {
      return handleCommaSeparatedValuesUpload(values);
    } else if (current === 0) {
      setCurrent(1);
      selectFileRef.current.handleFileSave(state.file);
    }
  };

  const getDisabledState = (isValid) => {
    if (current === 0 && isCommaSeparatedValues) {
      return !isValid;
    } else if (current === 0) {
      return state.file && state.file.customFileId ? false : true;
    } else if (current === 1) {
      return true;
    }
  };

  useEffect(
    () => {
      setState((st) => ({
        ...st,
        file: undefined,
        isReset: false,
        errorMessage: null,
      }));
    },
    [state.delimiter, state.selectFile],
  );
  useEffect(
    () => {
      if (state.useCustomFile !== "") {
        getSavedFileContent();
      }
    },
    [state.useCustomFile],
  );
  useEffect(() => {
    fetchBroadcastPatientList();
  }, []);

  const {
    fileUploaded,
    data,
    loading,
    showtable,
    headers,
    confirmPopup,
    filename,
    errorMessage,
    count,
    selectFile,
    fileId,
    customFileId,
  } = state;
  const isCommaSeparatedValues = state.delimiter === "commaSeparatedValues";
  const isMultiLangEnabledForCurrentMode =
    !isCommaSeparatedValues && state.isMultiLang;
  return (
    <Formik
      validateOnMount
      validateOnChange={false}
      validate={(values) => {
        const errors = {};
        const validationError = directTextInputValidation(values);

        if (Boolean(validationError?.length)) {
          errors.commaSeparatedText = validationError;
        }
        return errors;
      }}
      initialValues={{ messageType: "sms", commaSeparatedText: "" }}
      onSubmit={(values, actions) => {
        handleCommaSeparatedValuesUpload(values);
      }}
    >
      {({
        values,
        setFieldValue,
        touched,
        errors,
        isValid,
        dirty,
        validateForm,
        setFieldTouched,
      }) => {
        return (
          <>
            {!state.preview && (
              <>
                <div className="header-bar-mob">
                  <MobileHeader
                    showLogo={false}
                    showNotifications={false}
                    showHelp={false}
                    showAccountDetails={false}
                    showBackButton={true}
                    showPageTitle={true}
                    pageTitle="New Broadcast"
                    handleBackButton={backButtonClicked}
                  />
                </div>

                <div className="stepper">
                  <Steps
                    current={current}
                    direction="horizontal"
                    responsive={false}
                    size="small"
                  >
                    {steps.map((item) => (
                      <Step key={item.title} />
                    ))}
                  </Steps>
                </div>
              </>
            )}
            {customPopupMessage && (
              <CustomNotification messageType={messageType} message={message} />
            )}
            {confirmPopup && (
              <ConfirmPopup
                titleMessage={
                  state.saveFile
                    ? "Confirm to save & upload"
                    : "Confirm to upload"
                }
                handleCancel={hideConfirmPopup}
                handleDelete={upload}
                isVisible={confirmPopup}
                submitButtonText="Yes"
                cancelButtonText="No"
                message={
                  state.saveFile
                    ? "Are you sure you want to save & upload this file?"
                    : "Are you sure you want to upload this file without saving it for future use?"
                }
              />
            )}

            <div className="patient-main-container">
              <If condition={errorMessage}>
                <Then>
                  <section className="no-appointments-message">
                    <span className="message">
                      {ErrorYellowIcon} {errorMessage}
                    </span>
                  </section>
                </Then>
              </If>

              <If condition={loading}>
                <Then>
                  <div className="hide-for-mob">
                    {" "}
                    <LoadingSpinner customClassName="broadcast" />
                  </div>
                  <div className="display-in-mob">
                    {" "}
                    <LoadingSpinner customClassName="broadcast" type="large" />
                  </div>
                </Then>
              </If>

              <If condition={state.broadcastInitiated}>
                <Then>
                  <InitiateBroadcast
                    heading="Broadcast Initiated"
                    hideMessage={hideInitiateBroadcast}
                    handleResend={handleResend}
                    history={props.history}
                  />
                </Then>
              </If>

              <If condition={fileUploaded && !state.broadcastInitiated}>
                <Then>
                  <BroadcastMessage
                    loading={loading}
                    headers={headers}
                    data={data}
                    showTable={showtable}
                    fileName={filename}
                    customFileId={customFileId}
                    fileId={fileId}
                    broadcastMessage={broadcastMessage}
                    onCancel={cancel}
                    typeLabel="Patients"
                    fetchTableData={fetchTableData}
                    getSuggestions={getSuggestions}
                    count={count}
                    getScheduledMsgData={getScheduledMsgData}
                    showBroadcastResend={showBroadcastResend}
                    handleParentLoading={handleParentLoading}
                    current={current}
                    nextPage={next}
                    prevPage={prev}
                    isDirectTextInput={isDirectTextInput}
                    isMultiLang={isMultiLangEnabledForCurrentMode}
                    handleEmailTemplateData={handleEmailTemplateData}
                  />
                </Then>
                <Else>{null}</Else>
              </If>

              <If condition={!fileUploaded && !selectFile}>
                <Then>
                  <div className="broadcast-upload-container">
                    <div
                      className={`upload-section-container ${
                        state.delimiter === "commaSeparatedValues"
                          ? "no-upload-button"
                          : ""
                      }`}
                    >
                      {!state.preview && (
                        <h2 className="upload-section-header">
                          Upload patient file for broadcast message
                        </h2>
                      )}

                      {!state.preview && (
                        <p className="upload-section-info">
                          <strong>Note:</strong>{" "}
                          {isCommaSeparatedValues
                            ? "You can add maximum 50 Phone Numbers."
                            : "File should not exceed more than 8mb and 80k rows!"}
                        </p>
                      )}
                      <div className={state.preview ? "" : `radio-container`}>
                        {!state.preview && (
                          <CommonFields
                            name="delimiter"
                            type={"radio"}
                            value={state.delimiter}
                            defaultValue={"pipe"}
                            options={fileUploadOptions}
                            handleChange={handleTypeChange}
                          />
                        )}
                        <div className="display-in-mob">
                          <section>
                            {!state.saveFileLayout ? (
                              <>
                                {!state.preview &&
                                  state.delimiter !==
                                    "commaSeparatedValues" && (
                                    <UploadFile
                                      setFileData={setFile}
                                      name="file"
                                      handleRemove={handleResetFileData}
                                      isReset={state.isReset}
                                      fileFormat={
                                        state.delimiter === "comma"
                                          ? ["txt", "csv"]
                                          : "txt"
                                      }
                                      delimiter={state.delimiter}
                                    />
                                  )}
                              </>
                            ) : (
                              <>
                                {!state.preview && (
                                  <div className="save-container-mob">
                                    <div>
                                      <SaveFile
                                        showConfirmPopup={showConfirmPopup}
                                        getCustomeFileName={getCustomeFileName}
                                        file={state.file}
                                        responseError={state.fileNameError}
                                        resetFileNameErr={resetFileNameErr}
                                      />
                                    </div>
                                    <div style={{ textAlign: "end" }}>
                                      <CustomButton
                                        btntype="clear"
                                        title={
                                          PRACTICE_EDITION_WHITELABEL
                                            ? "Upload File"
                                            : "Back"
                                        }
                                        className="back-button"
                                        onClick={handleBack}
                                      />
                                    </div>
                                  </div>
                                )}
                              </>
                            )}
                          </section>
                        </div>
                      </div> 
                      {!state.preview &&
                        isTranslationEnable && (
                          <div className="language-section">
                            <CustomLabel title="Language" />
                            <div className="language-toggle-row">
                              <Switch
                                checked={isMultiLangEnabledForCurrentMode}
                                onChange={handleMultiLanguageToggle}
                                disabled={isCommaSeparatedValues}
                                className="language-toggle-switch"
                              />
                              <span className="language-toggle-label">
                                Multi-language Broadcast
                              </span>
                              <Tooltip
                                className="language-toggle-info"
                                title="Enable/disable multi-language broadcast, applicable for files based broadcast only."
                              >
                                {MultiLanguageInfoIcon}
                              </Tooltip>
                            </div>
                          </div>
                        )}
                        {!state.preview && IS_NON_PROD && (
  <div className="outreach-settings-section">
    <CustomLabel title="Outreach Settings" />
    <Tooltip title="For use only in non prod env">
      <span className="outreach-section-info">{MultiLanguageInfoIcon}</span>
    </Tooltip>
    <div className="outreach-toggle-row">
      <Switch
        checked={state.isTwilioDisabled}
        onChange={handleTwilioDisabledToggle}
        className="outreach-toggle-switch"
      />
      <span className="outreach-toggle-label">Disable Twilio</span>
      <Tooltip title="Disables outbound Twilio messages for test scenarios.">
        <span className="outreach-toggle-info">
          {MultiLanguageInfoIcon}
        </span>
      </Tooltip>
    </div>
    <div className="outreach-toggle-row">
      <Switch
        checked={state.allowDuplicate}
        onChange={handleAllowDuplicateToggle} 
        className="outreach-toggle-switch"
      />
      <span className="outreach-toggle-label">Allow Duplicate</span>
      <Tooltip title="Allows duplicate records to be included during outreach.">
        <span className="outreach-toggle-info">
          {MultiLanguageInfoIcon}
        </span>
      </Tooltip>
    </div>
  </div>
)}
                    </div>
                    <>
                      <>
                        {state.delimiter === "commaSeparatedValues" ? (
                          <Form className="direct-upload-form">
                            <section className="textarea-container">
                              <div className="textarea-and-label-container">
                                {" "}
                                <CustomLabel
                                  title="Enter Values"
                                  customClass="custom-label"
                                />
                                <div className="custom-textarea">
                                  <DebouncedDirectTextInput
                                    validateForm={validateForm}
                                  />
                                </div>
                              </div>
                              <CustomButton
                                htmlType="submit"
                                type="primary"
                                className={`custom-submit-button mt-16 ${
                                  !isValid ? "disable-button" : ""
                                }`}
                                disabled={!isValid}
                                title="Create Broadcast"
                              />
                            </section>
                          </Form>
                        ) : (
                          <section className="upload-file">
                            {!state.saveFileLayout ? (
                              <>
                                {" "}
                                <UploadFile
                                  setFileData={setFile}
                                  name="file"
                                  handleRemove={handleResetFileData}
                                  isReset={state.isReset}
                                  fileFormat={
                                    state.delimiter === "comma"
                                      ? ["txt", "csv"]
                                      : "txt"
                                  }
                                  delimiter={state.delimiter}
                                />
                                <CustomButton
                                  btntype="clear"
                                  title="Recent Uploads"
                                  className="recent-uploads"
                                  onClick={handleRecentUploads}
                                />
                              </>
                            ) : (
                              <div className="save-file-wrapper">
                                <div className="save-file-container">
                                  <SaveFile
                                    showConfirmPopup={showConfirmPopup}
                                    getCustomeFileName={getCustomeFileName}
                                    file={state.file}
                                    responseError={state.fileNameError}
                                    resetFileNameErr={resetFileNameErr}
                                  />
                                </div>
                                <CustomButton
                                  btntype="clear"
                                  title="Back"
                                  className="back-button"
                                  onClick={handleBack}
                                />
                              </div>
                            )}
                          </section>
                        )}
                      </>
                    </>
                  </div>
                </Then>

                <Else>{""}</Else>
              </If>

              <If condition={selectFile && !fileUploaded}>
                <Then>
                  <div
                    className="select-file-main-wrapper"
                    testId="select-file-wrapper"
                  >
                    <div className="select-file-flex-wrapper">
                      <div className="select-file-container">
                        <SelectFile
                          handleUseCustomFile={handleUseCustomFile}
                          editDeleteAccess={editDeleteAccess}
                          userType="patient"
                          handleLoading={handleLoading}
                          changePreview={handlePreview}
                        />
                      </div>
                    </div>
                    <CustomButton
                      btntype="clear"
                      title={
                        PRACTICE_EDITION_WHITELABEL ? "Upload File" : "Back"
                      }
                      className="back-button"
                      onClick={handleBack}
                    />
                  </div>
                </Then>
                <Else>{""}</Else>
              </If>
            </div>
            {!fileUploaded &&
              state.delimiter !== "commaSeparatedValues" && (
                <div
                  className={`recent-uploads-mob ${
                    state.saveFileLayout ? "margin-top-8" : ""
                  }`}
                >
                  <div
                    className="select-file-main-wrapper"
                    testId="select-file-wrapper"
                  >
                    {!state.preview && (
                      <div className="recent-uploads-header">
                        Recent Uploads
                      </div>
                    )}
                    <div className="select-file-flex-wrapper">
                      <div className="select-file-container">
                        <SelectFile
                          handleUseCustomFile={handleUseCustomFile}
                          editDeleteAccess={editDeleteAccess}
                          userType="patient"
                          handleLoading={handleLoading}
                          changePreview={handlePreview}
                          handleMobFileSelect={handleMobFileSelect}
                          ref={selectFileRef}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            {!state.preview &&
              current === 0 && (
                <div className="bottom-bar">
                  <BottomBar
                    handleBackButton={backButtonClicked}
                    handleNextButton={() => {
                      handleNextButton(values);
                    }}
                    disabled={getDisabledState(isValid)}
                  />
                </div>
              )}
          </>
        );
      }}
    </Formik>
  );
};

const mapDispatchToProps = (dispatch) => ({
  uploadBroadCastFile: bindActionCreators(
    uploadBroadCastFileNewAction,
    dispatch,
  ),
  uploadBroadCastCommaSeparatedValues: bindActionCreators(
    uploadBroadCastCommaSeparatedValuesAction,
    dispatch,
  ),
  broadCastMessage: bindActionCreators(broadCastMessageAction, dispatch),
  reviewBroadCastMessage: bindActionCreators(
    broadCastMessageReviewAction,
    dispatch,
  ),
  broadCastPatientList: bindActionCreators(
    broadCastPatientListAction,
    dispatch,
  ),
  removeBroadCastPatient: bindActionCreators(
    removeBroadCastPatientAction,
    dispatch,
  ),
  setPopup: (data) => dispatch(setPopup(data)),
  noInternetAction: () => dispatch(NoInternetAction()),
});

const mapStateToProps = (state) => ({
  patients: state.patients,
  user: state.login.user,
  popupReducer: state.popupReducer,
  noInternet: state.noInternet,
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(PatientBroadcast),
);
